import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './FuelSpent.css';
import { HiArrowLongLeft } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import fuel_icon from '../../assets/combustiveis_inicio.svg';
import fuel_diesel_icon from '../../assets/gasoleo.svg';
import fuel_gasoline_icon from '../../assets/gasolina.svg';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import { Modal } from 'react-responsive-modal';
import "react-responsive-modal/styles.css";

const FuelSpent = ({ fuelSpent, setFuelSpent, userInfo, setUserInfo }) => {
  const [formData, setFormData] = useState(fuelSpent);
  const [state, setState] = useState({
    openPopupEmail: false,
    email: "",
  });
  const { t } = useTranslation();
  const navigate = useNavigate(); // Para navegação programática

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleNavigateBack = (e) => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailInput = document.getElementById("modal-container-email");

    if (emailRegex.test(state.email)) {
      setUserInfo({ ...userInfo, email: state.email });
      setFuelSpent(formData);
      navigate('/carbon-footprint');
    } else {
      emailInput.classList.add("modal-container-email-error");
    }

  };


  const handleCheckboxChange = (event) => {
    const { name, value } = event.target;
    if (value && value.length > 0) {
      const numericValue = Math.max(0, Number(value)); // Garante que o valor seja >= 0

      if (numericValue) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: 0,
      }));
    }
  };

  const handleCalculateDialog = () => {
    setState({ ...state, openPopupEmail: true });
  };

  const handleChangeEmail = (value) => {
    setState({ ...state, email: value });
  };

  

  return (
    <div>
      <div className='form-background'>
        <div className='div-agroinsider-logo'>
          <img src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
        </div>
        <div className='div-page-logo'>
          <img className='img-page-logo' src={fuel_icon} alt="AgroInsider Logo" />
        </div>


        <div className='farm-profile-description'>
          <span className='farm-profile-title'>{t('FuelSpent.title')}</span>
          <p className='farm-profile-description-text'>{t('FuelSpent.description')}</p>
        </div>
        <div className="form-profile-form">
          <div className="form-group">
            <div className="nested-checkboxes">
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={fuel_diesel_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('FuelSpent.fuelOptions1')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0 (L/ano)'
                    className='input-animalProdution'
                    type="text"
                    name="diesel"
                    checked={formData.diesel}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.diesel}
                  />
                </div>
              </div>
              <hr></hr>
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={fuel_gasoline_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('FuelSpent.fuelOptions2')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0 (L/ano)'
                    className='input-animalProdution'
                    type="text"
                    name="gasoline"
                    checked={formData.gasoline}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.gasoline}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal
            open={state.openPopupEmail}
            onClose={() => setState({ openPopupEmail: false, email: "" })}
            center
            classNames={{
              modal: 'modal-container',
            }}
            showCloseIcon={false}
          >
            <div className='modal-div-container'>
              <span className='modal-container-title'>{t("FuelSpent.modalTitle")}</span>
              <span className='modal-container-description'>{t("FuelSpent.modalDescription")}</span>
              <input
                id='modal-container-email'
                type="email"
                placeholder="E-mail*"
                value={state.email}
                onChange={(e) => handleChangeEmail(e.target.value)}
                className="modal-container-input"
              />

              <div className="modal-container-buttons">
                <button className="modal-container-button" onClick={(e) => handleSubmit(e)}>{t('FuelSpent.buttonOk')}</button>
                <button className='form-back-button' onClick={() => setState(false)}>{t('FuelSpent.buttonCancel')}</button>
              </div>


            </div>
          </Modal>

        </div>
        <div className='form-group-bottom-buttons'>
          <div className="form-group-buttons">
            <button className='form-back-button' onClick={() => handleNavigateBack()}>
              <HiArrowLongLeft size={28} />
            </button>
            <button className="form-next-button" onClick={() => handleCalculateDialog()}>{t('FuelSpent.calculate')}</button>
          </div>
        </div>
        <LanguageSwitcher />
        <div className='div-logo-footer-color'>
          <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
        </div>
      </div>
    </div>
  );
}

export default FuelSpent;
